import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { BlockOrganizerForm } from '../../../features/organizer-blocks/components/block-organizer-form';
import { OrganizerBlocksTable } from '../../../features/organizer-blocks/components/organizer-blocks-table';
import { organizerBlocksOptions } from '../../../features/organizer-blocks/queries';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/organizer-blocks/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(organizerBlocksOptions()),
  component: OrganizerBlocksPage,
});

function OrganizerBlocksPage() {
  const { data: blocks } = useSuspenseQuery(organizerBlocksOptions());
  return (
    <div className="space-y-6">
      <PageHeader
        title="Блокировки организаторов"
        description="Посты заблокированного организатора не публикуются из импорта: автопубликация отклоняет их с пометкой, ручная — отказывает. Уже опубликованные события не трогаются."
      />
      <BlockOrganizerForm />
      <OrganizerBlocksTable blocks={blocks} />
    </div>
  );
}
